import { render } from "./CollectionDataEditor.vue?vue&type=template&id=d9f53218&scoped=true"
import script from "./CollectionDataEditor.vue?vue&type=script&lang=js"
export * from "./CollectionDataEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9f53218"]])

export default __exports__